import { useNavigate } from 'react-router-dom'

const styles = `
body{
    margin:0;
    font-family:'Open Sans',sans-serif;
    background:#f7f8fc;
}

.destination-hero{
    background:#1a2e6e;
    color:white;
    padding:80px 20px;
}

.destination-container{
    max-width:1100px;
    margin:auto;
}

.destination-hero h1{
    font-size:46px;
    margin-bottom:15px;
    font-family:'Nunito',sans-serif;
}

.destination-hero p{
    font-size:18px;
    max-width:720px;
    opacity:.95;
    line-height:1.8;
}

.destination-content{
    max-width:1000px;
    margin:50px auto;
    background:white;
    border-radius:16px;
    padding:45px;
    box-shadow:0 10px 30px rgba(0,0,0,.08);
}

.destination-content h2{
    color:#1a2e6e;
    margin-top:40px;
    margin-bottom:20px;
    font-size:30px;
}

.destination-content h3{
    color:#1a2e6e;
    margin-bottom:15px;
}

.destination-content p{
    line-height:1.9;
    color:#555;
}

.destination-content li{
    margin-bottom:15px;
    line-height:1.8;
}

.highlight{
    background:#eef8f2;
    border-left:6px solid #39b36a;
    padding:25px;
    border-radius:12px;
    margin-top:35px;
}

.process{
    background:#f5f7fb;
    border:1px solid #d8dfef;
    padding:20px;
    border-radius:12px;
    text-align:center;
    font-weight:700;
    color:#1a2e6e;
    margin:25px 0;
}

.back-btn{
    background:#f5a623;
    color:white;
    border:none;
    padding:12px 24px;
    border-radius:8px;
    cursor:pointer;
    font-weight:700;
    margin-bottom:30px;
}

.back-btn:hover{
    opacity:.9;
}

@media(max-width:768px){

.destination-hero{
    padding:55px 20px;
}

.destination-hero h1{
    font-size:34px;
}

.destination-content{
    margin:20px;
    padding:25px;
}

}
`

export default function SouthKoreaDestination() {
  const navigate = useNavigate()

  return (
    <>
      <style>{styles}</style>

      <section className="destination-hero">
        <div className="destination-container">
          <button className="back-btn" onClick={() => navigate('/', { state: { scrollTo: 'study-destinations' } })}>
            ← Back
          </button>

          <h1>🇰🇷 South Korea</h1>

          <p>
            From global technology giants like Samsung, LG, and Hyundai to top global university rankings, <strong>South Korea</strong> offers an exciting environment for ambitious
            international students.
          </p>
        </div>
      </section>

      <div className="destination-content">
        <h2>✨ Why Choose South Korea?</h2>

        <ul>
          <li>
            <strong>Global Korea Scholarship (GKS):</strong> Access fully government-funded scholarships covering tuition, round-trip flights, and monthly living stipends.
          </li>

          <li>
            <strong>Leading Innovation & Research Labs:</strong> World-class research opportunities in AI, Robotics, Engineering, Business, and Media Arts.
          </li>

          <li>
            <strong>High Post-Study Work Opportunities:</strong> Growing demand for skilled graduates with pathways to long-term employment.
          </li>

          <li>
            <strong>Modern & Safe Lifestyle:</strong> Experience advanced infrastructure, efficient transport, safe cities, and vibrant Korean culture.
          </li>
        </ul>

        <h2>📋 Essential Documents</h2>

        <ul>
          <li>
            <strong>Passport:</strong> Valid passport and national identity documents.
          </li>

          <li>
            <strong>Academic Certificates & Transcripts:</strong> Apostilled or ministry-attested educational documents.
          </li>

          <li>
            <strong>Family Relationship Certificate:</strong> Required for financial sponsorship verification.
          </li>

          <li>
            <strong>Bank Solvency Certificate:</strong> Proof of sufficient funds (typically USD 10,000–20,000 depending on the program).
          </li>

          <li>
            <strong>Personal Statement & Study Plan:</strong> Explain your academic goals and future plans.
          </li>

          <li>
            <strong>Language Certificate:</strong> TOPIK (Korean-taught programs) or IELTS/TOEFL (English-track programs).
          </li>
        </ul>

        <h2>🚀 Application & Visa Process</h2>

        <div className="process">Submit Application → Certificate of Admission (CoA) → D-2 Student Visa → Fly to South Korea 🇰🇷</div>

        <ol>
          <li>
            <strong>Apply During Intake:</strong> Submit your application during Spring (March) or Autumn (September) admission windows.
          </li>

          <li>
            <strong>Receive Certificate of Admission (CoA):</strong> Pay the required registration or tuition fee to receive your official admission certificate.
          </li>

          <li>
            <strong>Apply for D-2 Student Visa:</strong> Submit your CoA, financial documents, and academic records to the Korean Embassy.
          </li>

          <li>
            <strong>Arrive & Register:</strong> Travel to Korea and complete your Alien Registration Card (ARC) registration within 90 days.
          </li>
        </ol>

        <div className="highlight">
          <h3>🤝 How StudyBuddy Helps</h3>

          <ul>
            <li>
              <strong>Admission Timeline Management:</strong> We keep track of Korean admission deadlines so you never miss an intake.
            </li>

            <li>
              <strong>Study Plan & SOP Coaching:</strong> Professional guidance for writing strong personal statements and study plans.
            </li>

            <li>
              <strong>Document Verification:</strong> We help prepare attested, legalized, and embassy-ready documents.
            </li>

            <li>
              <strong>Financial Documentation:</strong> Assistance with bank solvency, sponsorship papers, and family relationship documents.
            </li>

            <li>
              <strong>Visa Assistance:</strong> End-to-end support throughout your D-2 visa application process.
            </li>

            <li>
              <strong>Arrival Support:</strong> Airport guidance, ARC registration, accommodation advice, and settling into student life.
            </li>
          </ul>
        </div>
      </div>
    </>
  )
}
